export { FeaturedArticleLink } from './FeaturedArticleLink';
export type { Props as FeaturedArticleLinkProps } from './FeaturedArticleLink';
